import React from "react";

export type StepInfo = { index: number; text?: string | null };

export function StepInfoBox({ index, text }: StepInfo) {
  return (
    <div className="w-full border-l-2 border-line bg-surface-card rounded-r-card pl-3 pr-2 py-2 text-xs text-ink-muted">
      <span className="font-semibold">Aus Schritt {index + 1}</span>
      {text && (
        <span className="block mt-0.5 leading-snug line-clamp-2">{text}</span>
      )}
    </div>
  );
}
